const ua = {
	translation: {
		// Шапка
		'Img magnifier': 'Збільшувач зображення',
		'Search city': 'Пошук міста',
		'Button select language': 'Кнопка вибору мови',
		'Button login': 'Кнопка входу',
		'Button profile': 'Кнопка профілю',
		'Search button': 'Кнопка пошуку',
		'To come in': 'Увійти',
		Profile: 'Профіль',

		// Підвал
		"Button to go to the creator's GitHub": 'Кнопка переходу на GitHub творця',
		'Powered by': 'Створенно',

		// Помилка
		'Page not found': 'Сторінку не знайдено',
		'Return back': 'Повернутися назад',
		'Button return back': 'Кнопка повернутися назад',
		Error: 'Помилка',

		// Реєстрація та вхід
		Email: 'Електронна пошта',
		Password: 'Пароль',
		'Input email': 'Введіть електронну пошту',

		// Вхід
		Login: 'Увійти',
		"I don't have an account": 'У мене немає аккаунту',
		'Forgot password': 'Забули пароль',
		"Button i don't have an account": 'Кнопка я ще не маю облікового запису',
		'Button to come in': 'Кнопка увійти',
		'Button forgot password': 'Кнопка забутий пароль',

		// Реєстрація
		Register: 'Зареєструватися',
		'Agree password': 'Підтвердження паролю',
		'I have an account': 'У мене вже є обліковий запис',
		'Button i have an account': 'Кнопка у мене вже є обліковий запис',
		'Button register': 'Кнопка зареєструватися',
		'Input password': 'Введіть пароль',
		'Input agree password': 'Введіть підтвердження паролю',

		// Профіль
		'My profile': 'Мій профіль',
		Exit: 'Вийти',
		'Profile image': 'Зображення профілю',
		'Button exit': 'Кнопка вийти',

		// WeatherCard
		en: 'ua',
		'km/h': 'км/год',
		'Img humindity': 'Зображення каплі',
		'Img wind': 'Зображення вітру',

		// WeatherNow
		'Img feel like': 'Картинка відчувається',
		'Feel like': 'Відчувається',
		Wind: 'Вітер',
		'Img visibility': 'Картинка видимості',
		Visibility: 'Видимість',
		'Img humidity': 'Картинка влажності',
		Humidity: 'Влажність',
		'Img pressure': 'Картинка тиску',
		Pressure: 'Тиск',
		'Img sea level': 'Картинка рівню морю',
		'Sea level': 'Рівень морю',
	},
};

export default ua;
